import axios from "../../../../configs/axiosIntereptor";
const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getAtomSDKs = () => {
    return axios.get(`${BASE_URL}/api/vpn/atom-sdks`);
  };
